import React from 'react';

export const Section = ({ children, className = '' }) => (
  <section className={`px-4 sm:px-6 lg:px-8 py-8 lg:py-12 ${className}`.trim()}>{children}</section>
);
